import React from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import './style/App.css';
import Nav from './Nav';
import Feedback from './Feedback';
import axios from 'axios';

const FeedbackRoute = () => {
  const params = useParams();
  const submitFeedbackContact = (feedbackResult) => {
    return axios.post('/Feedback/callBackend', { data: feedbackResult });
  };

  return (
    <div className='postRootDiv'>
      <Nav />
      <Feedback params={params} submitFeedbackContact={submitFeedbackContact} />
    </div>
  );
};

const RedirectToCts = () => {
  React.useEffect(() => {
    window.location.replace('https://www.cts-companies.com');
  }, []);

  return null;
};

function App() {
  return (
    <Routes>
      <Route path="/feedback/:srnumber/:score" element={<FeedbackRoute />} />
      <Route path="/feedback/:srnumber/:score/:email" element={<FeedbackRoute />} />
      <Route path="*" element={<RedirectToCts />} />
    </Routes>
  );
}

export default App;
